import _defineProperty from "/codebuild/output/src3618121175/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { unit } from '@ant-design/cssinjs';
import { prepareComponentToken, prepareToken } from '.';
import { genSubStyleComponent } from '../../theme/internal';
var genBorderedStyle = function genBorderedStyle(token) {
  var componentCls = token.componentCls;
  return _defineProperty(_defineProperty({}, "".concat(componentCls).concat(componentCls, "-bordered").concat(componentCls, "-disabled:not(").concat(componentCls, "-mini)"), _defineProperty(_defineProperty({
    '&, &:hover': _defineProperty({}, "".concat(componentCls, "-item-link"), {
      borderColor: token.colorBorder
    }),
    '&:focus-visible': _defineProperty({}, "".concat(componentCls, "-item-link"), {
      borderColor: token.colorBorder
    })
  }, "".concat(componentCls, "-item, ").concat(componentCls, "-item-link"), _defineProperty(_defineProperty({
    backgroundColor: token.colorBgContainerDisabled,
    borderColor: token.colorBorder
  }, "&:hover:not(".concat(componentCls, "-item-active)"), {
    backgroundColor: token.colorBgContainerDisabled,
    borderColor: token.colorBorder,
    a: {
      color: token.colorTextDisabled
    }
  }), "&".concat(componentCls, "-item-active"), {
    backgroundColor: token.itemActiveBgDisabled
  })), "".concat(componentCls, "-prev, ").concat(componentCls, "-next"), _defineProperty({
    '&:hover button': {
      backgroundColor: token.colorBgContainerDisabled,
      borderColor: token.colorBorder,
      color: token.colorTextDisabled
    }
  }, "".concat(componentCls, "-item-link"), {
    backgroundColor: token.colorBgContainerDisabled,
    borderColor: token.colorBorder
  }))), "".concat(componentCls).concat(componentCls, "-bordered:not(").concat(componentCls, "-mini)"), _defineProperty(_defineProperty({}, "".concat(componentCls, "-prev, ").concat(componentCls, "-next"), _defineProperty(_defineProperty(_defineProperty({
    '&:hover button': {
      borderColor: token.colorPrimaryHover,
      backgroundColor: token.itemBg
    }
  }, "".concat(componentCls, "-item-link"), {
    backgroundColor: token.itemLinkBg,
    borderColor: token.colorBorder
  }), "&:hover ".concat(componentCls, "-item-link"), {
    borderColor: token.colorPrimary,
    backgroundColor: token.itemBg,
    color: token.colorPrimary
  }), "&".concat(componentCls, "-disabled"), _defineProperty({}, "".concat(componentCls, "-item-link"), {
    borderColor: token.colorBorder,
    color: token.colorTextDisabled
  }))), "".concat(componentCls, "-item"), _defineProperty(_defineProperty({
    backgroundColor: token.itemBg,
    border: "".concat(unit(token.lineWidth), " ").concat(token.lineType, " ").concat(token.colorBorder)
  }, "&:hover:not(".concat(componentCls, "-item-active)"), {
    borderColor: token.colorPrimary,
    backgroundColor: token.itemBg,
    a: {
      color: token.colorPrimary
    }
  }), '&-active', {
    borderColor: token.colorPrimary
  })));
};
export default genSubStyleComponent(['Pagination', 'bordered'], function (token) {
  var paginationToken = prepareToken(token);
  return [genBorderedStyle(paginationToken)];
}, prepareComponentToken);